import script from "./ReminderPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReminderPop.vue?vue&type=script&lang=ts&setup=true"

import "./ReminderPop.vue?vue&type=style&index=0&id=235f5413&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235f5413"]])

export default __exports__